import React from "react";
import { useSelector } from "react-redux";

const PlanCard = ({
  planId,
  title,
  price,
  features,
  isLoading,
  isPopular,
  onStartTrial,
  onCancel,
  isActive,
  isYearly,
  trialAvailable,
  onApplyCoupon,
}) => {
  return (
    <div
      className={`flex flex-col max-w-sm w-72 rounded-xl p-6 ${
        isPopular 
          ? "shadow-glow border-2 border-primary bg-primary-bg" 
          : "bg-[#262626]"
      } sm:max-w-md`}
    >
      {/* Title and Most Popular Badge */}
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-bold text-white">{title}</h2>
        {isPopular && (
          <span className="bg-primary/40 text-white text-xs font-semibold px-2 py-1 rounded-md">
            Most Popular
          </span>
        )}
      </div>

      {/* Price */}
      <div className="mb-6">
        <div className="flex items-baseline">
          <span className="text-4xl font-bold text-primary">${price}</span>
          <span className="text-sm text-white ml-2">
            /{isYearly ? "year" : "month"}
          </span>
        </div>
      </div>

      {/* CTA Button */}
      <button
        onClick={isActive ? onCancel : onStartTrial}
        disabled={isLoading === planId}
        className="w-full bg-primary text-primary-dark font-bold py-2 px-4 rounded-lg hover:opacity-90 transition duration-300 flex justify-center items-center mb-6"
      >
        {isLoading === planId ? (
          <svg
            className="animate-spin h-5 w-5 text-primary-dark"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M12 2a10 10 0 0110 10h-4a6 6 0 00-6-6V2z"
            ></path>
          </svg>
        ) : isActive ? (
          "Cancel Subscription"
        ) : trialAvailable ? (
          "Start Trial"
        ) : (
          "Buy Now"
        )}
      </button>

      {/* Features Section */}
      <div className="mb-1">
        <p className="text-gray-400 mb-2">This Includes:</p>
        <ul className="space-y-1">
          {features.map((feature, index) => (
            <li key={index} className="text-white flex items-center">
              <svg
                className="w-5 h-5 text-primary mr-3 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                  d="M9 12l2 2 4-4"
                />
              </svg>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Apply Coupon Link - Only show for yearly plans */}
      {isYearly && onApplyCoupon && (
        <div>
          <button
            onClick={onApplyCoupon}
            className="text-primary underline text-sm font-medium hover:text-primary/80 transition-colors duration-200"
          >
            Apply coupon
          </button>
        </div>
      )}
    </div>
  );
};

export default PlanCard;
